import React from 'react'
import { gridCellLoaderStyles } from '../utils/gridCellImage.styles'

export const GridCellImageLoader = () => <div css={gridCellLoaderStyles} />
